import styled from 'styled-components'

export interface PerPageSelectProps {
  value: number
  options: number[]
  onChange: (value: number) => void
}

export const PerPageSelect = ({ value, options, onChange }: PerPageSelectProps) => (
  <Wrap>
    שורות בעמוד
    <Select value={value} onChange={(e) => onChange(Number(e.target.value))}>
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </Select>
  </Wrap>
)

export default PerPageSelect

const Wrap = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: ${({ theme }) => theme.text.md};
  color: ${({ theme }) => theme.colors.ink3};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: none;
  }
`

const Select = styled.select`
  appearance: none;
  -webkit-appearance: none;
  font: inherit;
  font-size: ${({ theme }) => theme.text.md};
  color: ${({ theme }) => theme.colors.ink};
  background-color: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  border-radius: ${({ theme }) => theme.radii.sm};
  padding: 5px 10px 5px 26px;
  cursor: pointer;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23757575' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>");
  background-repeat: no-repeat;
  background-position: left 8px center;
`
